const helperMatomo = function (app) {

    const $document = $(document);
    const clickSelector = "[data-js-matomo-click]";

    const init = function () {

        // don't risk registering matomo events more than once a page
        if (!app.matomoReady) {
            app.matomoReady = true;
            registerEvents();
        }
    };

    const push = function (obj) {
        if( !obj ){
            return { status: 'NoData'};
        }

        if (window._mtm) {
            if (showDebug) {
                console.log("Matomo: _mtm: " + JSON.stringify(obj))
            }
            window._mtm.push(obj);
            return { status: 'Ok'};
        }
        else {
            if (showDebug) {
                console.log("Matomo: No _mtm: " + JSON.stringify(obj))
            }
            return { status: 'NoMtm'};
        }
    };

    const registerEvents = function () {

        $document.on('click', clickSelector, function (ev) {

            const $el = (ev ? $(this) : false);
            if( !$el ){
                return;
            }
            const matomoEvent =$el.attr('data-js-matomo-event');
            if( matomoEvent ) {
                push( JSON.parse(matomoEvent) );
            }
        });

        if( window.useMatomo2023 === true ){
            $document.on('click', '.giosg_chat_now', function (ev) {
                push( { 'event': 'chat_init' } );
            });
        }

    };

    return {
        init: init(),
        push: push
    };

};

export default helperMatomo;